import { BusinessCardStack } from './business-card-stack';
import type { CardData } from '../../../../print-cards/card-data';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { PlantlifeCheapWeedBusinessCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/business-cards-2x3/plantlife/plantlife-cheap-weed-business-card-stack-content/plantlife-cheap-weed-business-card-stack-content.component';

export class PlantlifeCheapWeedBusinessCardStack extends BusinessCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> | null {
    // card has mandatory white border around it, so background lives within content component
    return null;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> | null {
    return PlantlifeCheapWeedBusinessCardStackContentComponent;
  }
}
